import React from 'react';
import { Resizable } from 'react-resizable';
import { resizableTitle } from '../../../interfaces/resizableTitle';

const ResizableTitle: React.FC<
  Readonly<React.HTMLAttributes<HTMLElement> & resizableTitle>
> = ({ onResize, width, className, ...restProps }) => {
  if (!width) {
    return <th {...restProps} />;
  }

  const isResizable = Boolean(onResize);
  const minWidth = 50;
  const isFixedRight = className?.includes('ant-table-cell-fix-right');

  return (
    <Resizable
      width={Number(width)}
      height={0}
      handle={
        <span
          className={`resize-handle ${isResizable ? '' : 'non-resizable'}`}
          onMouseUp={(e) => e.stopPropagation()}
        />
      }
      onResize={onResize}
      draggableOpts={{ enableUserSelectHack: false }}
      minConstraints={[minWidth, 0]}
    >
      <th
        {...restProps}
        className={`resizable-header ${className || ''} ${
          isFixedRight ? 'ant-table-cell-fix-right-first' : ''
        }`}
      >
        {restProps.children}
      </th>
    </Resizable>
  );
};

export default ResizableTitle;
